<template>
  <ib-guided-tour
    tour-name="ideaPlanTour"
    :steps="tourSteps"
    :show-intro-dialog="showIntroDialog"
    :intro-delay="1000"
    @tour-start="$emit('tour-start')"
    @tour-end="$emit('tour-end')"
    @intro-skip="$emit('intro-skip')"
  >
    <template #intro-image>
      <img src="@/assets/img/onboarding/idea.svg" alt="" style="width: 125px;">
    </template>
    <template #intro>
      <h1 class="text-center mb-2 font-outfit-semi-bold">
        {{ $t('pages.ideaPlan.tour.introTitle') }}
      </h1>
      <p class="text-center" style="font-size: 18px;">
        {{ $t('pages.ideaPlan.tour.introText') }}
      </p>
    </template>
  </ib-guided-tour>
</template>

<script>
export default {
  name: 'CanvasTour',

  props: {
    showIntroDialog: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tourSteps () {
      return [
        {
          target: '.items__center .items__horizontal:nth-child(1) .item:nth-child(1) .flex',
          header: { title: this.$t('pages.ideaPlan.tour.step1Title') },
          content: this.$t('pages.ideaPlan.tour.step1Content'),
          params: {
            placement: 'bottom',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.items__center',
          header: { title: this.$t('pages.ideaPlan.tour.step2Title') },
          content: this.$t('pages.ideaPlan.tour.step2Content'),
          params: {
            placement: 'left',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.align-self-end > .d-flex',
          header: { title: this.$t('pages.ideaPlan.tour.step3Title') },
          content: this.$t('pages.ideaPlan.tour.step3Content'),
          params: {
            placement: 'bottom',
            enableScrolling: false,
            highlight: true
          }
        }
      ]
    }
  }
}
</script>
